import { traverse } from '../traverse/traverse';
export function filter(adf, callback) {
  var result = [];
  traverse(adf, {
    any: function any(node) {
      if (callback(node)) {
        result.push(node);
      }
    }
  });
  return result;
}